var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showCont)?[_c('myHeader',{attrs:{"userInfo":_vm.userInfo}}),_c('div',{staticClass:"cont contBox"},[_c('div',{staticClass:"left"},[_c('leftMenu')],1),_c('div',{staticClass:"left_cont"},[_c('router-view')],1)])]:[_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }